import axios from "axios"
import toastr from "toastr"


const PUBLIC_URLS = [
  'auth'
];

const URL_API_SERVICE = process.env.REACT_APP_API_BASE_URL;

const api = axios.create({
  baseURL: URL_API_SERVICE,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/ld+json',
  },
});

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('authUser');
    if (token && !PUBLIC_URLS.includes(config.url)) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur de réponse pour gérer les erreurs 401
api.interceptors.response.use(
  response => response,
  async (error) => {

    if (error.response && error.response.status === 401) {
      localStorage.removeItem('authUser');
    }

    return Promise.reject(error);
  }
);

const handleError = (error) => {
  if (error.response) {
    return { error: error.response.data };
  } else if (error.request) {
    return { error: 'Aucune réponse de l\'API' };
  } else {
    return { error: error.message };
  }
};

// Fonctions d'API
export const get = async (url, params = {}) => {
  try {
    return await api.get(url, { params })
  } catch (error) {
    return handleError(error);
  }
};

export const post = async (url, data = {}) => {
  try {
    return await api.post(url, data);
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const patch = async (url, data = {}, config = {}) => {
  try {
    return await api.patch(url, data, config);
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const put = async (url, data = {}) => {
  try {
    return await api.put(url, data);
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const upload = async (url, data = {}) => {
  try {

    return await api.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  } catch (error) {
    handleError(error);
    throw error;
  }
};


export const del = async (url) => {
  try {
    return await api.delete(url);
  } catch (error) {
    return handleError(error);
  }
};

export function handleApiError(error) {
  const data = error?.response?.data ?? error ?? {};
  let messages = [];

  if (Array.isArray(data.violations) && data.violations.length > 0) {
    messages = data.violations.map((v) => v.message);
  }
  // Cas API Platform (hydra:description)
  else if (typeof data['hydra:description'] === 'string') {
    messages = [data['hydra:description']];
  }
  // Autres messages standard
  else if (typeof data.message === 'string') {
    messages = [data.message];
  } else if (typeof data.detail === 'string') {
    messages = [data.detail];
  } else {
    messages = ['Une erreur est survenue. Veuillez réessayer.'];
  }

  messages.forEach(msg => {
    toastr.error(msg, '');
  });

  return messages;
}
